<div class="p-grid">
    <div class="p-col-6">
        {{getVersionText()}}
    </div>
    <div class="p-col-6">
        <span class="pull-right">{{l('Copyright', currentDateTime.getFullYear())}}</span>
    </div>
</div>
